import {Component} from '@angular/core';
import {BaseComponent} from '../../shared/base-components/base.component';

@Component({
    selector: 'logout',
    templateUrl: './logout.html'
})

export class LogoutComponent extends BaseComponent {

    constructor(){
        super();
    }
    redirectForLogin() {
        localStorage.removeItem('menuItems');
        localStorage.removeItem('mvd:windowId');
        // We are going to cache the mvmDeepLink into a backup slot 'mvmDeepLink2'
        // This is because the login.component.ts is loaded twice and 'mvmDeepLink'
        // will be overwritten with a different URI in the second load
        localStorage.setItem('mvmDeepLink', localStorage.getItem('mvmDeepLinkTemp'));
        this.auth.login();
    }
    ngOnInit() {
    }
}
